/**
 * FIXME We can create reservedDetail and reservedStatus in this source.  But I have time enough.
 **/
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useLocation } from 'react-router-dom';

import { useDrizzleContext } from "../drizzle/drizzleContext";

import * as ReserveActions from './actions';
import ReservePage from './ReservePage';

/**
 * Note that without Loading container when we refresh this page, React returns drizzle as undefined.
 **/
const ReservePageContainer = ({
  dispatch,
  contracts,
  accounts,
  transactions,
  transactionStack,
  synced,
  fetched,
  added,
  processing,
  savedConfirmedQueue,
  confirmedQueueFromSearchPage,
  txCount
}) => {
  const pathname = useLocation().pathname;

  const SECONDS_OF_DAYS = 24 * 60 * 60;
  const NUM_OF_DAYS = 7;
  const TIME_BIN = 30 * 60;

  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.THDJabraToken;

  const [ dataKey, setDataKey ] = useState("");
  const [ jabraTokens, setJabraTokens ]  = useState(null);
  const [ reserveOfDays, setReserveOfDays ] = useState(null);
  const [ stackLen, setStackLen ] = useState(0);

  const [ stackId, setStackId ] = useState(null);
  const [ reserveQueueElm, setReserveQueueElm ] = useState({});
  const [ cancelQueueElm, setCancelQueueElm ] = useState({});
  const [ confirmedQueue, setConfirmedQueue ] = useState([]);

  const [ targetDay, setTargetDay ] = useState(new Date());

  const [ jabraNumber, setJabraNumber ] = useState(1);
  const [ open, setOpen ] = useState(false);

  const [ confirmedReserve, setConfirmedReserve ] = useState({ stackId: null, confirmedStart: null, confirmedEnd: null });

  useEffect(() => {
    dispatch(initReserve());
  }, [targetDay, jabraNumber]);

  useEffect(() => {
    // FIXME Adjust to the display of the calender.
    if (fetched) 
      return

    const year = targetDay.getFullYear();
    const month = targetDay.getMonth();
    const date = targetDay.getDate();
    const day = targetDay.getDay();
    const sunday = date - day;

    const startString = new Date(year, month, sunday);
    const start = Math.floor(startString.getTime() / 1000);
    const end = Math.floor(startString.setDate(startString.getDate() + NUM_OF_DAYS) / 1000);
    show(jabraNumber-1, start, end); // jabraNumber begins at 1.  But in Solidity, jabraNumber begins at 0.
  }, [contracts, synced, fetched, targetDay, jabraNumber]);

  // HACK by using reducer I want to handle with the problem that contracts isn't updated.
  useEffect(() => {
    if (fetched)
      return;

    if (dataKey !== null) {
      setJabraTokens(fetchTokens(dataKey));
      setDataKey(null);
    }
  }, [contracts, dataKey]);

  useEffect(() => {
    if (fetched)
      return;

    setReserveOfDays(splitByDay(jabraTokens));
  }, [jabraTokens]);

  useEffect(async () => {
    if (Object.keys(reserveQueueElm).length === 0)
      return;

    const { _jabraNumber, _startTime, _endTime } = reserveQueueElm;

    const start = _startTime / 1000;
    const end = _endTime / 1000;

    const estimatedGas = await contract.methods.reserveTokensForPeriod(
          _jabraNumber, start, end
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const gasMultiplication = 1.1;
    const gasPriceMultiplication = 1.1;
    const nonce = await drizzle.web3.eth.getTransactionCount(accounts[0])+txCount;

    const stackId = await contract.methods["reserveTokensForPeriod"].cacheSend(_jabraNumber, start, end, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*gasMultiplication),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
      nonce: nonce
    });

    setConfirmedReserve({
      type: 'reserve',
      stackId: stackId,
      _jabraNumber: _jabraNumber+1,
      confirmedStart: _startTime,
      confirmedEnd: _endTime
    })
    setStackId(stackId);
  }, [reserveQueueElm]);

  useEffect(async () => {
    if (Object.keys(cancelQueueElm).length === 0)
      return;

    const { _jabraNumber, _startTime, _endTime } = cancelQueueElm;

    const start = _startTime / 1000;

    const estimatedGas = await contract.methods.cancelTokensForPeriod(
          _jabraNumber, start
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const gasMultiplication = 1.1;
    const gasPriceMultiplication = 1.1;
    const nonce = await drizzle.web3.eth.getTransactionCount(accounts[0])+txCount;

    const stackId = await contract.methods["cancelTokensForPeriod"].cacheSend(_jabraNumber, start, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*gasMultiplication),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
      nonce: nonce
    });

    setConfirmedReserve({
      type: 'cancel',
      stackId: stackId,
      _jabraNumber: _jabraNumber+1,
      confirmedStart: _startTime,
      confirmedEnd: _endTime
    })
    setStackId(stackId);
  }, [cancelQueueElm]);

  useEffect(() => {
    const length = transactionStack.length;
    if (length === stackLen)
      return;

    const txHash = transactionStack[stackId];

    if (transactions[txHash] && transactions[txHash].status === 'pending' && transactions[txHash].confirmations.length === 0) {
      setStackLen(length);
      setConfirmedQueue([...confirmedQueue, confirmedReserve]);
    }
  }, [transactions]);

  useEffect(() => {
    let newConfirmedQueue = confirmedQueue;

    for (let i = 0; i < confirmedQueue.length; i++)
      if (transactions[transactionStack[confirmedQueue[i].stackId]].status === 'success') {
        newConfirmedQueue = newConfirmedQueue.filter(elm => elm.stackId !== confirmedQueue[i].stackId);
        setConfirmedQueue([...newConfirmedQueue]);
      }
  }, [transactions]);

  useEffect(() => {
    if (confirmedQueue.length === 0)
      return;

    dispatch(notifyManipulateReserve(confirmedQueue));
  }, [confirmedQueue]);

  useEffect(() => {
    if (savedConfirmedQueue.length === 0)
      return;

    setConfirmedQueue([...savedConfirmedQueue]);
  }, [pathname]);

  useEffect(() => {
    if (confirmedQueueFromSearchPage.length === 0)
      return;

    setConfirmedQueue([...confirmedQueue, ...confirmedQueueFromSearchPage]);
  }, [confirmedQueueFromSearchPage]);

  const reserve = (jabraNumber, startTime, endTime) => {
    dispatch(notifyAddedConfirmation());
    setReserveQueueElm({
      _jabraNumber: jabraNumber,
      _startTime: startTime,
      _endTime: endTime
    });
  }

  const cancel = async (jabraNumber, startTime, endTime) => {
    dispatch(notifyAddedConfirmation());
    setCancelQueueElm({
      _jabraNumber: jabraNumber,
      _startTime: startTime,
      _endTime: endTime
    });
  }

  const show = async (jabraNumber, start, end) => {
    if (!synced)
      return;

    var _dataKey = await contract.methods.showReserveOfAllOwners.cacheCall(jabraNumber, start, end);

    if (_dataKey === null)
      _dataKey = 0;

    setDataKey(_dataKey);
  }

  const fetchTokens = dataKey => {
    if (!synced)
      return;

    var jabraTokensString = null;
    var middleStateTokens = null;
    var tokenId;
    var owner;
    var reserveTime;
    var reservedTime;
    const reserveTimeShift = 8;

    jabraTokensString = contracts.THDJabraToken.showReserveOfAllOwners[dataKey] 
      ? contracts.THDJabraToken.showReserveOfAllOwners[dataKey].value
      : null;

    if (jabraTokensString !== undefined && jabraTokensString !== null) {
      middleStateTokens = [];
      for (let i = 0; i < jabraTokensString.length; i++) {
        tokenId = parseInt(jabraTokensString[i].tokenId);
        owner = jabraTokensString[i].owner;
        reserveTime = (tokenId - (tokenId % (2 ** reserveTimeShift)))/ (2 ** reserveTimeShift); // Note that unsigned right shift >>> doesn't work well because of the limit of integers.
        reservedTime = parseInt(jabraTokensString[i].reservedTime);
        middleStateTokens[i] = {
          tokenId: tokenId,
          owner: owner,
          reserveTime: reserveTime,
          reservedTime: reservedTime,
          next: jabraTokensString[i].next
        };
      }
    }
    // FIXME I'll write this logic as reducer().
    return calculateTimeRange(middleStateTokens);
  }

  const calculateTimeRange = middleStateTokens => {
    var calculated = null;
    var startTime = -1;
    var endTime = -1;

    if (middleStateTokens === null)
      return null;
    else
      calculated = [];

    const sorted = middleStateTokens.slice().sort((a, b) => { // FIXME Is this array really copied and remain unchanged?
      if (a.reserveTime > b.reserveTime)
        return 1;
      else
        return -1;
    });

    var j = 0;
    for (var i = 0; i < sorted.length; i++) {
      startTime = sorted[i].reserveTime;
      endTime = startTime + TIME_BIN;

      if (!sorted[i].next) {
        if (i === 0 || !sorted[i-1].next) {
          calculated[j] = {
            tokenId: sorted[i].tokenId,
            owner: sorted[i].owner,
            startTime: startTime,
            endTime: endTime,
            reservedTime: sorted[i].reservedTime
          };
          j++;
        } else {
          calculated[j] = {
            tokenId: calculated[j].tokenId,
            owner: sorted[i].owner,
            startTime: calculated[j].startTime,
            endTime: endTime,
            reservedTime: calculated[j].reservedTime
          };
          j++;
        }
      } else {
        if (i === 0 || !sorted[i-1].next) {
          calculated[j] = {
            tokenId: sorted[i].tokenId,
            owner: sorted[i].owner,
            startTime: startTime,
            reservedTime: sorted[i].reservedTime
          };
        }
      }
    }
    return calculated;
  }

  const splitByDay = jabraTokens => {
    if (!synced)
      return;

    var array = [];

    const year = targetDay.getFullYear();
    const month = targetDay.getMonth();
    const date = targetDay.getDate();
    const day = targetDay.getDay();
    const sunday = date - day;
    const startOfWeek = new Date(year, month, sunday);
    var base = Math.floor(startOfWeek.getTime() / 1000);
    var i = 0;
    var j = [];

    for (i = 0; i < NUM_OF_DAYS; i++)
      array[i] = [];

    for (i = 0; i < NUM_OF_DAYS; i++)
      j[i] = 0;

    if (jabraTokens === null || jabraTokens === undefined)
      return;

    for (var index = 0; index < jabraTokens.length; index++) {
      i = (jabraTokens[index].startTime - base - ((jabraTokens[index].startTime - base) % SECONDS_OF_DAYS)) / SECONDS_OF_DAYS;
      array[i][j[i]++] = jabraTokens[index];
    }
    dispatch(didInitReserve())
    return array;
  }

  const makeDaysOfWeek = day => {
    var year = day.getFullYear();
    var month = day.getMonth();
    var date = day.getDate();
    var dayNum = day.getDay();
    var sunday = date - dayNum;
    var curDay = new Date(year, month, sunday);
    var week = [];

    for (var i = 0; i < NUM_OF_DAYS; i++) {
      week[i] = new Date(curDay.getTime());
      curDay.setDate(curDay.getDate() + 1);
    }
    return week;
  }

  const [ week, setWeek ] = useState(makeDaysOfWeek(targetDay));

  // Note that React re-renders a display if we set new variable to setVariable() of useState().  Is this statement correct?
  const onClickToday = e => {
    const day = new Date();

    const week = makeDaysOfWeek(day);
    setWeek(week);
    setTargetDay(day);
  }

  const onClickChangeDay = e => {
    const day = new Date(e.target.dataset.date);
    setTargetDay(new Date(day.getFullYear(), day.getMonth(), day.getDate()));
  }

  const onClickPrevious = () => {
    const previousInteger = targetDay.setDate(targetDay.getDate() - NUM_OF_DAYS);
    const previous = new Date(previousInteger);
    setTargetDay(previous);
    const week = makeDaysOfWeek(targetDay);
    setWeek(week);
  }

  const onClickNext = () => {
    const nextInteger = targetDay.setDate(targetDay.getDate() + NUM_OF_DAYS);
    const next = new Date(nextInteger);
    setTargetDay(next);
    const week = makeDaysOfWeek(targetDay);
    setWeek(week);
  }

  const onClickEle = number => {
    setJabraNumber(number);
    setOpen(!open);
  }

  const onClickDropdown = e => {
    setOpen(!open);
  }

  if (fetched) {
    if (reserveOfDays === null) {
      dispatch(initReserve());
      return (
        <div className="atom-spinner">
          <div className="spinner-inner">
            <div className="spinner-line"></div>
            <div className="spinner-line"></div>
            <div className="spinner-line"></div>
            <div className="spinner-circle">
              &#9679;
            </div>
          </div>
         </div>
      );
    }
    return (
      <ReservePage
        reserve={reserve}
        cancel={cancel}
        open={open}
        reserveOfDays={reserveOfDays}
        targetDay={targetDay}
        week={week}
        onClickChangeDay={onClickChangeDay}
        onClickToday={onClickToday}
        onClickPrevious={onClickPrevious}
        onClickNext={onClickNext}
        jabraNumber={jabraNumber}
        onClickEle={onClickEle}
        onClickDropdown={onClickDropdown}
      />
    );
  } else
    return (
      <div className="atom-spinner">
        <div className="spinner-inner">
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-circle">
            &#9679;
          </div>
        </div>
       </div>
    );
}

const initReserve = () => {
  return {
    type: ReserveActions.RESERVE_INITIALIZING
  }
}

const didInitReserve = () => {
  return {
    type: ReserveActions.RESERVE_INITIALIZED
  }
}
const notifyAddedConfirmation = () => {
  return {
    type: ReserveActions.RESERVE_ADDED
  }
}

const notifyManipulateReserve = confirmedQueue => {
  return {
    type: ReserveActions.RESERVE_CHANGE_QUEUE,
    confirmedQueue: confirmedQueue
  }
}

const notifyCompleteReserve = confirmedQueue => {
  return {
    type: ReserveActions.RESERVE_COMPLETED,
    confirmedQueue: confirmedQueue
  }
}

const mapStateToProps = state => {
  return {
    contracts: state.contracts,
    accounts: state.accounts,
    transactions: state.transactions,
    transactionStack: state.transactionStack,
    synced: state.reserve.synced,
    fetched: state.reserve.fetched,
    added: state.reserve.added,
    processing: state.reserve.processing,
    savedConfirmedQueue: state.reserve.confirmedQueue,
    confirmedQueueFromSearchPage: state.token.confirmedQueueFromSearchPage,
    txCount: state.reserve.txCount
  };
};

export default connect(mapStateToProps)(ReservePageContainer);
